
import { defineComponent, ref, watch } from 'vue'
import { Form, useForm } from 'vee-validate'
import FormPhone from '@/components/form/FormPhone.vue'
import useLoading from '@/composables/useLoading'

export default defineComponent({
  components: {
    Form,
    FormPhone
  },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update', 'close'],
  setup(props, { emit }) {
    const { loading, setSearch } = useLoading(false)
    const telefono = ref<string>('')
    const telefonoError = ref<string | null>(null)
    const error = ref<string | null>(null)
    const { handleSubmit } = useForm()

    watch(
      () => telefono.value,
      (nuevoTelefono: string) => {
        const numericValue = nuevoTelefono.toString().replace(/\D/g, '').slice(0, 10)
        if (telefono.value !== numericValue) {
          telefono.value = numericValue
        }

        if (!nuevoTelefono || nuevoTelefono.toString().length !== 10) {
          telefonoError.value = 'El teléfono debe tener 10 números'
        } else {
          telefonoError.value = null
        }
      }
    )

    const onSubmit = handleSubmit(async () => {
      try {
        error.value = null
        setSearch(true, 'Actualizando teléfono')
        emit('update', telefono.value)
      } catch (e: any) {
        error.value = 'Error al actualizar el teléfono. Por favor, intente de nuevo.'
        setSearch(false, '')
      }
    })

    return {
      telefono,
      telefonoError,
      error,
      loading,
      onSubmit
    }
  }
})
